import React, { useEffect } from 'react';
import {
    IGetExpertsProps,
    EditExperts,
    ISubmitExpertsProps,
} from 'components';
import { push } from 'connected-react-router';
import { connect } from 'react-redux';
import { Dispatch, IRootState } from '../../redux/store/configureStore';
import { useLocalErrorHandler } from 'hooks';

const NewExamEditExpertsContainer = ({
    setErrorHandler,
    apiError,
    onPush,
    getAvailableExperts,
    setExperts,
    experts,
    exam,
}: Props) => {
    useLocalErrorHandler(setErrorHandler);

    useEffect(() => {
        if (!exam.qualificationId || !exam.qualificationEvaluationCenterId) {
            onPush('/new-exam');
        }
    }, []);

    const handleAcceptExpert = (data: ISubmitExpertsProps) => {
        setExperts(data);
        onPush('/new-exam');
    };

    const handleClickCancel = () => {
        onPush('/new-exam');
    };

    const onGetExperts = async (data: IGetExpertsProps) => {
        await getAvailableExperts({
            onlyEmployees: !!data.onlyQecEmployees,
            qualificationId: exam.qualificationId,
        });
    };

    return exam.qualificationId && exam.qualificationEvaluationCenterId ? (
        <EditExperts
          experts={experts}
          getExperts={onGetExperts}
          submitSelectExperts={handleAcceptExpert}
          handleClickCancel={handleClickCancel}
          apiError={apiError}
          initSelectedExperts={{
                invitedExpertIds: exam.invitedExpertIds,
                chairmanId: exam.committeeChairmanId,
            }}
        />
    ) : null;
};

const mapState = (state: IRootState) => ({
    exam: state.exam,
    experts: state.experts.availableExpertsList,
    apiError: state.errors.error,
});

const mapDispatch = (dispatch: Dispatch) => ({
    onPush: (key: string) => dispatch(push(key)),
    getAvailableExperts: dispatch.experts.getAvailableExpertsAsync,
    setExperts: dispatch.exam.setExperts,
    setErrorHandler: dispatch.errors.setErrorHandler,
});

export default connect(mapState, mapDispatch)(NewExamEditExpertsContainer);

type Props = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>;
